import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, breakpoints, spacing, sizes } = redesignTheme;

export const useAuthLayoutStyles = makeStyles(() => ({
  layout: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: colors.background,
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      flexDirection: 'row',
      height: '100vh',
      overflow: 'hidden',
    },
  },
  panel: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: colors.background,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: `${spacing.md}px ${spacing.sm}px ${spacing.lg}px`,
    boxSizing: 'border-box' as const,
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      maxWidth: '50%',
      height: '100vh',
      padding: `${45}px ${spacing.sm}px ${spacing.lg}px`,
    },
  },
  panelInner: {
    width: '100%',
    maxWidth: sizes.contentMaxWidth,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 0,
  },
  logoWrap: {
    flexShrink: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  contentInner: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingTop: spacing.md,
  },
}));
